import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PublicSharedModule } from '../../../public-shared/public-shared.module';
import { SharedModule } from '../../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { QRCodeModule } from 'angularx-qrcode';
import { BuyerContainerComponent } from './container/buyer-container/buyer-container.component';
import { EventComponent } from './components/event/event.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { ProductUnavalibleComponent } from './container/product-unavalible/product-unavalible.component';
import { BuyerViewComponent } from './container/buyer-view/buyer-view.component';
import { SellerViewComponent } from './container/seller-view/seller-view.component';
import { PhysicalProductComponent } from './components/physical-product/physical-product.component';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { CalendarComponent } from './components/booking/calendar.component';
import { AdsComponent } from './components/ads/ads.component';
import { ReadMoreComponent } from './components/read-more/read-more.component';
import { QuickPaymentComponent } from './components/quick-payment/quick-payment.component';
import { EventBannerDetailsComponent } from './components/event/shared/event-banner-details/event-banner-details.component';
import { EventTermsSectionComponent } from './components/event/shared/event-terms-section/event-terms-section.component';
import { ReservationComponent } from './components/reservation/reservation.component';
import { ClaimComponent } from './components/claim/claim.component';

const buyerContainerRoutes: Routes = [
  { path: '', component: BuyerContainerComponent },
];

@NgModule({
  declarations: [
    BuyerContainerComponent,
    ProductUnavalibleComponent,
    BuyerViewComponent,
    SellerViewComponent,
    EventComponent,
    InvoiceComponent,
    PhysicalProductComponent,
    SubscriptionComponent,
    CalendarComponent,
    QuickPaymentComponent,
    AdsComponent,
    ReadMoreComponent,
    EventBannerDetailsComponent,
    EventTermsSectionComponent,
    ReservationComponent,
    ClaimComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(buyerContainerRoutes),
    PublicSharedModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    QRCodeModule,
  ]
})
export class BuyerContainerModule { }
